<template>
  <div>
    <Row justify="center" type="flex" style="background: #ffffff">
      <Col span="24">
        <img
          style="width: 100%"
          src="../../../static/img/solutions/safetyhelmet/banner.png"
          alt="#"
        />
      </Col>
      <Col span="24" class="ContactUs_1">
        <div class="box_1">
          <div
            class="tab-item"
            @click="switching(1)"
            :class="{ active: isSHOW == 1 }"
          >
            <div class="box_font">
              <div>行业现状</div>
              <div v-if="isSHOW == 1">
                <img
                  style="width: 30px; height: 30px; margin: 103px 0 0px 10px"
                  src="../../../static/img/solutions/artificialintelligence/button.png"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div
            class="tab-item"
            @click="switching(2)"
            :class="{ active: isSHOW == 2 }"
          >
            <div class="box_font">
              <div>政策支持</div>
              <div v-if="isSHOW == 2">
                <img
                  style="width: 30px; height: 30px; margin: 103px 0 0px 10px"
                  src="../../../static/img/solutions/artificialintelligence/button.png"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div
            class="tab-item"
            @click="switching(3)"
            :class="{ active: isSHOW == 3 }"
          >
            <div class="box_font">
              <div>创新价值</div>
              <div v-if="isSHOW == 3">
                <img
                  style="width: 30px; height: 30px; margin: 103px 0 0px 10px"
                  src="../../../static/img/solutions/artificialintelligence/button.png"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
        <div class="box_2">
          <div class="box_3">
            <!-- 动态切换内容 -->
            <div v-if="isSHOW === 1">
              <div style="margin-top: 10px">
                <div style="font-size: 20px">安全事故预知难</div>
                <div>
                  工地建筑安全事故多发，且建筑安全事故多会造成严重的后果，工地安全事故难以预知成为工地主要管理痛点之一。
                </div>
              </div>
              <div style="margin-top: 10px">
                <div style="font-size: 20px">工地用工管理难</div>
                <div>
                  工地施工时间长，涉及工种多且杂，因此人员的流动性较大，如果对工人进行有效且实时的管理成为管理的一大难点。
                </div>
              </div>
            </div>
            <div v-if="isSHOW === 2">
              <div style="margin-top: 10px">
                <div style="font-size: 20px">国家政策强制要求智慧工地落地</div>
                <div>
                  住建部门陆续出台施工现场智能化管理规范，强制推动AI安全帽识别、人员实名制、安全预警系统在工地普及落地。
                </div>
              </div>
            </div>
            <div v-if="isSHOW === 3">
              <div style="margin-top: 10px">
                <div style="font-size: 20px">降本增效，规避安全责任风险</div>
                <div>
                  利用AI视觉识别自动监管工人佩戴安全帽，减少人工巡检成本，降低安全事故追责风险，提升项目数字化管理水平。
                </div>
              </div>
            </div>
          </div>
        </div>
      </Col>
      <Col span="24" class="ContactUs_2">
        <div>
          <div class="contactus_font">系统</div>
          <div style="margin-top: 40px">
            <div style="display: flex; justify-content: center">
              <div class="box_scsl"></div>
              <div class="box_scsl1"></div>
            </div>
            <div style="display: flex; justify-content: center">
              <div class="box_scsl2"></div>
              <div class="box_scsl3"></div>
            </div>
          </div>
        </div>
      </Col>
      <Col span="24" class="ContactUs_3">
        <div class="box_tital">产品展示</div>
        <div style="display: flex; justify-content: center">
          <div class="box">
            <div
              v-for="(item, index) in WisdomSiteList"
              :key="index"
              class="box_content"
            >
              <div>
                <img
                  style="width: 300px; height: 300px"
                  :src="item.photoUrl"
                  alt=""
                />
              </div>
              <div style="margin-top: 15px">
                <div class="box_name">{{ item.ref }}</div>
                <div
                  style="
                    width: 94px;
                    height: 0px;
                    border: 2px solid #1f58ff;
                    margin: 0 auto;
                  "
                ></div>
              </div>
            </div>
          </div>
        </div>
      </Col>
    </Row>
  </div>
</template>
<script>
export default {
  name: "ContactUs",
  data() {
    return {
      isSHOW: 1,
      imgActiveIndex: 0,
      imgDistance: 0,
      allDistance: 0,
      WisdomSiteList: [
        {
          photoUrl: "../../../static/img/WisdomSite/WisdomSiteKan.jpg",
          ref: "数字孪生管理平台",
        },
        {
          photoUrl: "../../../static/img/WisdomSite/Positioning.png",
          ref: "人员安全帽定位系统",
        },
        {
          photoUrl: "../../../static/img/WisdomSite/Theraise.png",
          ref: "智能标养室",
        },
        {
          photoUrl: "../../../static/img/WisdomSite/detection.png",
          ref: "物联网智能水表",
        },
        {
          photoUrl: "../../../static/img/WisdomSite/discharge1.png",
          ref: "卸料平台监测系统",
        },
        {
          photoUrl: "../../../static/img/WisdomSite/5GTowercrane.png",
          ref: "5G智能塔机模型",
        },
        {
          photoUrl: "../../../static/img/WisdomSite/5Gelevator.png",
          ref: "5G智能升降机模型",
        },
        {
          photoUrl: "../../../static/img/WisdomSite/SecurityCheck.png",
          ref: "临边防护检测系统",
        },
        {
          photoUrl: "../../../static/img/WisdomSite/Highsupportdie1.png",
          ref: "高支模监测系统",
        },
        {
          photoUrl: "../../../static/img/photo/measurement.png",
          ref: "大体积混凝土测温",
        },
        {
          photoUrl: "../../../static/img/WisdomSite/RFID.png",
          ref: "RFID应用",
        },
        {
          photoUrl: "../../../static/img/WisdomSite/Distribution.png",
          ref: "配电箱安全管理系统",
        },
        {
          photoUrl: "../../../static/img/WisdomSite/smoke.png",
          ref: "智能烟感系统",
        },
        {
          photoUrl: "../../../static/img/WisdomSite/Foggun.png",
          ref: "环境监测联动喷淋雾炮",
        },
        {
          photoUrl: "../../../static/img/WisdomSite/monitor.png",
          ref: "塔机安全监控系统",
        },
        {
          photoUrl: "../../../static/img/WisdomSite/Personalservice.png",
          ref: "劳务实名制",
        },
        {
          photoUrl: "../../../static/img/WisdomSite/positioning1.png",
          ref: "物料车辆定位系统",
        },
        {
          photoUrl: "../../../static/img/WisdomSite/monitoring.png",
          ref: "视频监控系统",
        },
        {
          photoUrl: "../../../static/img/WisdomSite/yangchen.png",
          ref: "环境监测系统",
        },
        {
          photoUrl: "../../../static/img/WisdomSite/nut.png",
          ref: "塔吊预警螺母",
        },
        {
          photoUrl: "../../../static/img/WisdomSite/Thecollision.png",
          ref: "群塔作业防碰撞系统",
        },
        {
          photoUrl: "../../../static/img/WisdomSite/shijingshapan.png",
          ref: "实景沙盘联动系统",
        },
        {
          photoUrl: "../../../static/img/WisdomSite/Exhibitionhall.png",
          ref: "物联网智能展厅",
        },
        {
          photoUrl: "../../../static/img/WisdomSite/videoAI.png",
          ref: "视频AI",
        },
        {
          photoUrl: "../../../static/img/WisdomSite/xunjianjiqiren.png",
          ref: "智能巡检机器人",
        },
        {
          photoUrl: "../../../static/img/WisdomSite/broadcast.png",
          ref: "智慧广播",
        },
        {
          photoUrl: "../../../static/img/WisdomSite/Commandcenter.png",
          ref: "指挥中心控屏",
        },
        {
          photoUrl: "../../../static/img/WisdomSite/Vehicleidentification.png",
          ref: "车辆识别系统",
        },
      ],
    };
  },
  mounted() {},
  methods: {
    switching(item) {
      this.isSHOW = item;
    },
  },
};
</script>
<style scoped>
.ContactUs_1 {
  height: 700px;
  background-color: #f7f8fa;
  display: flex;
}
.box_font {
  width: 170px;
  height: 46px;
  font-family: SourceHanSansCNRegular;
  font-size: 26px;
  color: #ffffff;
  display: flex;
  margin-right: 70px;
}
.box_1 {
  width: 45%;
  margin-top: -5px;
  background-color: #1b2e64;
}
.tab-item {
  width: 787px;
  height: 196px;
  border-bottom: 1px solid #6d91f7;
  margin-left: auto;
  line-height: 230px;
  cursor: pointer;
}
.box_2 {
  width: 55%;
  background-image: url("../../../static/img/solutions/actualmeasurement/Earth.png");
  background-size: 100% 100%;
  margin-top: -5px;
}
.ContactUs_2 {
  height: 850px;
  background-image: url("../../../static/img/solutions/actualmeasurement/three.png");
  background-size: 100% 100%;
}
.box_scsl {
  width: 713px;
  height: 284px;
  background-image: url("../../../static/img/solutions/safetyhelmet/1.png");
  background-size: 100% 100%;
  border-radius: 12px;
  margin: 0 10px 10px 0;
}
.box_scsl1 {
  width: 713px;
  height: 284px;
  background-image: url("../../../static/img/solutions/safetyhelmet/4.png");
  background-size: 100% 100%;
  border-radius: 12px;
}
.box_scsl2 {
  width: 713px;
  height: 284px;
  background-image: url("../../../static/img/solutions/safetyhelmet/3.png");
  background-size: 100% 100%;
  border-radius: 12px;
  margin: 0 10px 10px 0;
}
.box_scsl3 {
  width: 713px;
  height: 284px;
  background-image: url("../../../static/img/solutions/safetyhelmet/2.png");
  background-size: 100% 100%;
  border-radius: 12px;
}
.active {
  border-bottom: 3px solid #6d91f7;
}
.contactus_font {
  margin-top: 2%;
  font-weight: 500;
  font-size: 42px;
  color: #343e51;
  font-family: SourceHanSansCN;
  text-align: center;
}
.box_3 {
  width: 753px;
  height: 224px;
  background: rgba(13, 28, 71, 0.8);
  border-radius: 4px;
  margin: 118px 0 0 61px;
  font-family: SourceHanSansCNRegular;
  font-weight: 400;
  color: #ffffff;
  padding: 10px;
}
.ContactUs_3 {
  height: 2950px;
  background-image: url("../../../static/img/solutions/smartsite/one.png");
  background-size: 100% 100%;
}
.ContactUs_3 .box {
  width: 1442px;
  height: 1640px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
.ContactUs_3 .box_tital {
  height: 61px;
  font-family: SourceHanSansCN;
  font-weight: 500;
  font-size: 42px;
  text-align: center;
  padding: 20px 0 80px 0;
}
.ContactUs_3 .box_content {
  height: 380px;
  background: #ffffff;
  margin: 10px;
}
.ContactUs_3 .box_name {
  height: 32px;
  font-family: OPPOSans;
  font-weight: 500;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/solutions/smartsite.vue